<template>
  <div>
    <group :title="$t('cart.payment.info')" class="p-1">
      <cell :title="$t('cart.payment.orderNumber')" :value="orderNumber"></cell>
      <cell :title="$t('cart.payment.actualAmount')" :value="actualAmount"></cell>
      <cell :title="$t('cart.payment.currency')" :value="$t('kol.priceUnit')"></cell>
    </group>
    <!-- <div v-if="type == 'D'" style="padding: 30px"><x-button type="primary" @click.native="payByCredit" >確認</x-button></div>
    <div v-transfer-dom>
      <alert v-model="status" title="提醒" :button-text="$t('general.confirm')" @click.native="$router.push('/product')">你已成功以積分付款</alert>
    </div> -->
    <group v-if="type == 'S'" :title="$t('cart.payment.stripe')" class="p-1">
      <flexbox orient="vertical">
        <flexbox-item>
          <Card class='stripe-card'
          :class='{ complete }'
          :stripe="stripe"
          :options='stripeOptions'
          @change='complete = $event.complete'
          />
        </flexbox-item>  
        <flexbox-item class="text-right p-2">
          <b-button class='pay-with-stripe' variant="primary" @click='pay' :disabled='paid || !complete'><i class="fa fa-credit-card"></i> {{$t('cart.payment.pay')}}</b-button>
        </flexbox-item>  
      </flexbox>
    </group>
    <group v-if="type == 'T'" :title="$t('cart.payment.transfer')" class="p-1">
      <flexbox orient="vertical">
        <flexbox-item>
          <span class="transfer">客人結帳時可使用以下銀行入帳付款 :<br><br>
          滙豐銀行<br>
          A/C : 747-062693-838<br><br>
          *於下單後，客人必須3天內完成入帳並須上傳已入帳的銀行收據或截圖，結帳時的款項與銀行入帳的款項必須一致，否則不予處理及將影響發貨的流程。
          <br>
          *於收到客人上傳的收據後，我們需1-3個工作天與銀行核對款項。成功核實, 方可發貨。<br>
          *所有截圖煩請盡量顯示清楚入數日期，時間及銀碼，方便我司查核。
          </span>
        </flexbox-item>  
        <flexbox-item>
          <FITImageUpload ref="imageUpload" v-model="uploadImage" />
        </flexbox-item>  
        <flexbox-item class="text-right p-2">
          <b-button class='pay-with-stripe' variant="primary" @click='transfer'><i class="fas fa-exchange-alt"></i> {{$t('cart.payment.transfer')}}</b-button>
        </flexbox-item>  
      </flexbox>
    </group>
    <div v-transfer-dom>
      <loading :show="makingPayment" :text="$t('cart.payment.makingPayment')"></loading>
    </div>
    <div v-transfer-dom>
      <alert v-model="errorPayment" :button-text="$t('general.confirm')">{{$t('cart.payment.errorPayment')}}</alert>
    </div>
    <div v-transfer-dom>
      <alert v-model="errorCard" :button-text="$t('general.confirm')">{{$t('cart.payment.errorCard')}}</alert>
    </div>
<!--     <div v-transfer-dom>
      <alert v-model="paid" @on-hide="$router.replace('/product/myShop')">{{$t('cart.payment.success')}}</alert>
    </div> -->
  </div>
</template>
<script type="text/javascript">

//  import { stripeKey, stripeOptions } from '../stripeConfig.js'
  import { Card, createToken } from 'vue-stripe-elements-plus'
  import {FITImageUpload} from '@/components'
  import { Alert, Group, Cell, Flexbox, FlexboxItem, Loading, TransferDomDirective as TransferDom, XButton } from 'vux'
  import wx from 'weixin-js-sdk';


  export default {
    name: 'Payment',
    directives: {
      TransferDom
    },  
    components: {
      Card,
      Group, 
      Cell,
      Flexbox, 
      FlexboxItem, 
      Loading,
      Alert,
      FITImageUpload,
      XButton
    },
    props: {
      orderID: String,
      orderNumber: String,
      paymentMethod: String,
      actualAmount: [Number, String],
      currency: String,
      type: String
    },
    data() {
      return {
        stripe:'pk_live_frzE5wobbfyM3WDKH5fzp8ZW',
        stripeOptions: {
        // see https://stripe.com/docs/stripe.js#element-options for details
      },
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      paid:false,
      makingPayment:false,
      errorPayment:false,
      errorCard:false,
      userName:null,
      password:null,
      url:'https://kolpartner.com/kol-rest/product/link/',
      wrong:false,
      quantity:1,
      customerName:'',
      email:'',
      telephone:'',
      address:'',
      source:'http://bootstrap-ecommerce.com/main/images/items/1.jpg',
      uploadImage:"",
      getImageUrl:"",
      status: false,
    }
  },
  created() {
    document.title = this.$t('kol.footer.payment');
    this.$store.commit("hideFooter", true);
  },
  mounted() {
    this.$nextTick(function () {
      this.getWechatConfig();
    })    
  },
  watch: {},
  computed: {},
  methods: {
    pay () {
      this.makingPayment = true;

      createToken().then(data => {

        this.$store.dispatch('Cart/pay',{
          orderID: this.orderID,
          paymentMethod: 'S',
          stripeToken:data.token.id,
          link:this.link

        }).then((json) => {
          this.makingPayment = false;
          if(json.status == 200){
            this.paid = true;
            this.$router.replace('/cart/payment/success');
          }
          else{
            this.paid = false
          }
        })
        .catch((err) => {
          alert(err)
          console.error(err);
        })
      })
      .catch((err)=>{
        this.paid = false;
        this.makingPayment = false;
        this.errorCard = true;
        console.error(err)
      })
    },
    transfer(){
      this.makingPayment = true;
      this.$refs.imageUpload.formUploadFiles();

      this.$store.dispatch("Package/uploadImage",{
        file:this.uploadImage.files
      }).then((json) => {
        if(json.status == 200){
          this.getImageUrl = json.data
          this.uploadReceipt();
        }
        else{
          this.paid = false;
        }
        console.log(json);
        this.$refs.imageUpload.initialize();
      }).catch((err) => {
        this.paid = false;
        this.makingPayment = false;
        console.error(err)
      })
    },
    uploadReceipt(){
      this.$store.dispatch("Package/uploadReceipt",{
        orderID:this.orderID,
        receipt:this.getImageUrl
      }).then((json) => {
        if(json.status == 200){
          this.paid = true;
          this.$router.replace('/account/order')
        }
        else{
          this.paid = false;
        }
      }).catch((err) => {
        this.paid = false;
        this.makingPayment = false;
        console.error(err)
      })
    },
    getWechatConfig(){
      // let url = location.href.split('#')[0] //获取锚点之前的链接
      //   this.$http.get('/index.php',{
      //     params: {
      //       url: url
      //     }
      //   }).then(response => {
      //       let res = response.data;
      //       this.wxInit(res);
      //     })

      // wxInit(res) {
      //   // let url = location.href.split('#')[0] //获取锚点之前的链接 
      //   // let links = url+'#/Food/' + this.$route.params.id;
      //   // let title = this.detail.name + '-嘌呤查';
      //   // let desc = '了解更多知识，请关注“嘌呤查”公众号';
      //   // let imgUrl = this.thumb;
      //   wx.config({
      //     debug: false,
      //     appId: res.appId,
      //     timestamp: res.timestamp,
      //     nonceStr: res.nonceStr,
      //     signature: res.signature,
      //     jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone']
      //   });    
    },
    wechatPay(){

    },
    payByCredit(){
      this.$store.dispatch('Cart/pay', {
        orderID: this.orderID,
        paymentMethod: 'D',
        actualAmount:  this.actualAmount
      })
      .then((json) => {
    
      if(json.status == 401){
        Cookies.remove('token');
        this.$router.push('/login?type=1');
      }else if(json.status == 200){
        this.status = true
        this.$router.replace('/cart/payment/success');
      }else{
        alert(json.message);
      }
      }).catch((err) => {
          console.error(err);
      });
    },


  },
}

</script>
<style type="text/css">
.stripe-card {
  background-color: white;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  border: 1px solid transparent;
  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}
.stripe-card.complete {
  border-color: green;
}
.credit-card-inputs.complete {
  border: 2px solid green;
}
.mt1rem{margin-top:1rem;}
.transfer{
  color:#999999;
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/Package/containers/Payment.vue